const base_Api = "https://fine-ant-jumper.cyclic.app";

export { base_Api };
